import { ShieldAlert } from "lucide-react";
import { useSOS } from "../../context/SOSContext";

/**
 * The red "Offline SOS" badge in the header.
 *
 * The DOM id MUST stay `sos-toggle-btn` and class MUST contain `sos-badge`
 * (user-contracted markers used by scripts / monitoring tooling).
 */
export function SOSToggleButton({ className = "" }) {
  const { open, openPanel, isOnline, queueSize } = useSOS();
  return (
    <button
      type="button"
      id="sos-toggle-btn"
      onClick={openPanel}
      aria-label="Abrir modo SOS offline"
      aria-pressed={open}
      data-testid="sos-toggle"
      className={`sos-badge ${className}`}
    >
      <ShieldAlert size={13} strokeWidth={2.6} aria-hidden="true" />
      <span className="sos-badge-text">
        {isOnline ? "Offline SOS" : "SOS offline"}
      </span>
      {!isOnline && queueSize > 0 && (
        <span className="sos-badge-count" aria-label={`${queueSize} mensajes en cola`}>
          {queueSize}
        </span>
      )}
    </button>
  );
}
